export const ResourceVisibility = {
	JUST_ME: 'JUST_ME',
	IS_VOD: 'IS_VOD',
	ALL: 'ALL',
	BEEYOU: 'BEEYOU',
	ORGANIZATION: 'ORGANIZATION',
	SPECIFIC_USERS: 'SPECIFIC_USERS',
	CHANNEL_ONLY: 'CHANNEL_ONLY',
};
